import {Component} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {AlarmService} from '../../../../../../../services/alarm.service';
import {ButtonIconComponent} from '../../../../../../../shared/components/button-icon/button-icon.component';
import {InputSelectComponent} from '../../../../../../../shared/components/input-select/input-select';
import {TranslateSafePipe} from '../../../../../../../shared/pipes/translation.pipe';
import {AlarmRuleConditionHasAlarmCheckTypeConfig} from '../../../../../../../types/dtos/alarm-rule-condition.dto';
import {AlarmType} from '../../../../../../../types/enums/alarm.enum';
import {InputSelectInterface} from '../../../../../../../types/interfaces/input.interface';
import {BaseCondition} from '../base-condition';
import {BaseRuleCondition} from '../base-rule-condition';
import {HasAlarmCheckRuleCondition} from './has-alarm-check.rule-condition';

@Component({
  selector: 'app-has-alarm-check',
  imports: [
    InputSelectComponent,
    ButtonIconComponent,
    TranslateSafePipe,
  ],
  templateUrl: './has-alarm-check.html',
  styleUrls: [
    './has-alarm-check.css',
    '../base-rule-condition.css'
  ],
})
export class HasAlarmCheck extends BaseCondition {
  override ruleCondition: BaseRuleCondition = new HasAlarmCheckRuleCondition();

  constructor(
    private readonly _alarmService: AlarmService,
    private readonly _translateService: TranslateService
  ) {
    super();
  }

  public get getDefaultValueString(): string {
    const config = this.getConfig() as unknown as AlarmRuleConditionHasAlarmCheckTypeConfig | undefined;

    const alarmTypeText = this._translateService.instant(
      'common.enum.alarm-type.' + config?.alarmType
    );

    const existsText = config?.exists
      ? this._translateService.instant('common.input.check-as.values.alarm-exist')
      : this._translateService.instant('common.input.check-as.values.alarm-not-exist');

    return `${alarmTypeText} - ${existsText}`;
  }

  public getAlarmTypeInput(): InputSelectInterface {
    return {
      formGroup: this.formGroup,
      id: 'alarmType',
      isTranslated: true,
      label: 'common.table.alarm-type.label',
      required: true,
      options: Object.values(AlarmType)
        .map((key) => ({
          isTranslated: true,
          label: 'common.enum.alarm-type.' + key,
          value: key,
        }))
    };
  }

  public getExistsInput(): InputSelectInterface {
    return {
      formGroup: this.formGroup,
      id: 'exists',
      isTranslated: true,
      label: 'common.input.check-as.label',
      required: true,
      options: [
        {
          isTranslated: true,
          label: 'common.input.check-as.values.alarm-exist',
          value: 'true',
        },
        {
          isTranslated: true,
          label: 'common.input.check-as.values.alarm-not-exist',
          value: 'false',
        },
      ],
    }
  }
}
